export default __webpack_public_path__ + "static/media/bbot-logo-white.e7b43323.svg";